import { Outlet, Route } from "react-router";

import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { DistributionOverview } from "./DistributionOverview";

export const useDistributionRouter = () => {
    return (
        <Route path="distribution" element={<DistributionFeatureGate />}>
            <Route index element={<DistributionOverview />} />
        </Route>
    );
};

const DistributionFeatureGate = () => {
    const { isFeatureActivated, isLoading } = useApplicationParameters();

    if (isLoading) {
        return null;
    }

    if (!isFeatureActivated("FS-manage-my-distribution")) {
        return <Forbiddenpage />;
    }

    return <Outlet />;
};
